import React, { useState, useEffect, useRef } from "react";
import "./modal.scss";

import ReactPlayer from "react-player"


const SuccessModal = (props) => {
  const [playing, setPlaying] = useState(false);
  const playerRef = useRef(null);

  useEffect(() => {
    if (props.isOpen) {
      // Auto play video when modal opens
      setTimeout(() => {
        setPlaying(true);
      }, 300);
    } else {
      setPlaying(false);
    }
  }, [props.isOpen]);

  return (
    <div className={`sucess__modal ${props.isOpen ? 'modal-content-open' : ''} ${props.isClosing ? 'modal-content-closing' : ''}`}>
      <button onClick={props.closeModal} className='close-button'>×</button>
      <div className='player_wrapper'>
        <ReactPlayer
          ref={playerRef}
          url={props.link}
          controls
          playing={playing}
          width='80%'
          height='90%'
          />
      </div>
    <div className='modal_contents'>
      <div className='modal-info-row'>
        <span className='modal-label'>type:</span>
        <span className='modal-value'>{props.tag}</span>
      </div>
      <div className='modal-info-row'>
        <span className='modal-label'>service:</span>
        <span className='modal-value'>
          {props.service.join(' | ')}
        </span>
      </div>
      {props.client.length > 0 && (
        <div className='modal-info-row'>
          <span className='modal-label'>client:</span>
          <span className='modal-value'>
            {props.client.join(' | ')}
          </span>
        </div>
      )}
    </div>




    {/* <p>
    <b>Services</b>
    {
      props.service
        .map(item => <span>{item}</span>)
        .reduce((acc, x) => acc === null ? [x] : [acc, ' | ', x], null)
    }
    </p>
    <p><b>Client</b>
    {
      props.client
        .map(item => <span>{item}</span>)
        .reduce((acc, x) => acc === null ? [x] : [acc, ' | ', x], null)
    }
    </p> */}
    </div>
  );
};

export default SuccessModal;
